import React from "react";
import BexChat from "../assets/bex-chat.JPG";
import Robibon from "../assets/robibon.JPG";
import GPACalc from "../assets/ReactGPACalc.jpg";
import TaskTracker from "../assets/ReactProjectTaskTracker.png";
import DiscordClone from "../assets/DiscordClone.PNG";
import TodoListVanilla from "../assets/Todolist.PNG";

const Work = () => {
  return (
    <div
      name="work"
      className="w-full sm:h-[90vh] h-[230vh] text-gray-300 bg-[#0a192f]"
    >
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 text-gray-300 border-cyan-600">
            Work
          </p>
          <p className="py-6">|| Check out some of my recent works</p>
        </div>

        {/* Container */}
        <div className="bg-left grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          {/* Grid Item */}
          <div
            style={{
              backgroundImage: `url(${BexChat})`,
              backgroundPosition: `left`,
            }}
            className="bg-left shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover Effects */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider">
                BexChat React-GraphQL
              </span>
              <div className="pt-8 text-center">
                <a href="https://bex-chat.vercel.app">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-[#0a192f] hover:text-white">
                    Live Demo
                  </button>
                </a>
              </div>
            </div>
          </div>
          {/* Grid Item */}
          <div
            style={{
              backgroundImage: `url(${Robibon})`,
              backgroundPosition: `left`,
            }}
            className="bg-left shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover Effects */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider">
                Website I built for a Client
              </span>
              <div className="pt-8 text-center">
                <a href="https://www.robibonconstruction.com/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-[#0a192f] hover:text-white">
                    Live Site
                  </button>
                </a>
              </div>
            </div>
          </div>
          {/* Grid Item */}
          <div
            style={{
              backgroundImage: `url(${GPACalc})`,
              backgroundPosition: `left`,
            }}
            className="bg-left shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover Effects */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider">
                GPA Calculator ReactJS
              </span>
              <div className="pt-8 text-center">
                <a href="https://drive.google.com/file/d/1BXO00sgJCPd9j4LJVYrPaXPoEuJZTa5h/view?usp=sharing">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-[#0a192f] hover:text-white">
                    Demo Video
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div
            style={{ backgroundImage: `url(${TaskTracker})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover Effects */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider">
                React Task Tracker MERN App
              </span>
              <div className="pt-8 text-center">
                <a href="https://github.com/Beki-D/react-task-tracker">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-[#0a192f] hover:text-white">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div
            style={{ backgroundImage: `url(${DiscordClone})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover Effects */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider">
                React Discord Clone
              </span>
              <div className="pt-8 text-center">
                <a href="https://github.com/Beki-D/discord-dashboard-clone-tw">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-[#0a192f] hover:text-white">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
          {/* Grid Item */}
          <div
            style={{ backgroundImage: `url(${TodoListVanilla})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/*Need to fix the weird text margin issue here!!! Between
              breakpoints 750px and 950px*/}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider mx-auto">
                Vanilla JS Application
              </span>
              <div className="pt-8 text-center">
                <a href="https://my-advanced-todo-app.vercel.app/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-[#0a192f] hover:text-white">
                    Demo
                  </button>
                </a>
                <a href="https://github.com/Beki-D/My-advanced-todo-app">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-[#0a192f] hover:text-white">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
